import styled from 'styled-components';
import Select from "react-select";
import InputMask from "react-input-mask";

export const WarningContainer = styled.div `
  position: relative;
  display: flex;
  justify-content: center;
  padding: 10px 0;
  background: transparent;
`;

export const WarningWrapper = styled.div `
  width: 100%;
  margin-bottom: 20px;
`;

/** Shell da aba Ambiental */
export const EngineeringRoot = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 0.75rem 1rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media screen and (max-width: 768px) {
    padding: 0.5rem 0.65rem 1.75rem;
    gap: 0.75rem;
  }
`;

export const EngineeringLoading = styled.p`
  margin: 1.5rem 1rem;
  color: var(--text-secondary);
  font-size: 0.95rem;
`;

/** Menu interno: grid no desktop, scroll horizontal no mobile */
export const SubNav = styled.nav`
  width: 100%;
  box-sizing: border-box;
`;

export const SubNavGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0.45rem;
  width: 100%;

  @media screen and (max-width: 1100px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 0.45rem;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    padding-bottom: 0.35rem;
    margin: 0 -0.15rem;
    padding-left: 0.15rem;
    padding-right: 0.15rem;

    &::-webkit-scrollbar {
      height: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--border-default);
      border-radius: 4px;
    }
  }
`;

export const SubNavItem = styled.button`
  appearance: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0.45rem;
  width: 100%;
  min-height: 52px;
  text-align: left;
  border-radius: 12px;
  background: ${({ $active }) =>
    $active ? "var(--accent-soft)" : "var(--surface-2)"};
  border: 2px solid
    ${({ $active }) => ($active ? "var(--accent)" : "var(--border-subtle)")};
  color: var(--text-primary);
  padding: 0.55rem 0.75rem;
  transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s ease;
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1.25;
  box-sizing: border-box;

  &:hover {
    border-color: ${({ $active }) =>
      $active ? "var(--accent)" : "var(--accent-secondary)"};
    background: ${({ $active }) =>
      $active ? "var(--accent-soft)" : "var(--surface-1)"};
  }

  @media screen and (max-width: 768px) {
    flex: 0 0 auto;
    width: auto;
    max-width: 11.5rem;
    min-width: 9.5rem;
    min-height: 44px;
    padding: 0.5rem 0.7rem;
    font-size: 0.72rem;
    border-radius: 999px;

    .subnav-label-full {
      display: none;
    }

    .subnav-label-short {
      display: inline;
    }
  }

  .subnav-label-short {
    display: none;
  }

  .subnav-label-full {
    display: inline;
  }
`;
export const SubNavIcon = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  font-size: 0.95rem;
  color: ${({ $active, $color }) => ($active ? "var(--text-primary)" : $color)};
`;

export const SubNavLabel = styled.span`
  min-width: 0;
  overflow-wrap: anywhere;
`;

export const Panel = styled.section`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const OdsSection = styled.div`
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  background: var(--surface-1);
  border: 1px solid var(--border-subtle);
  border-radius: 14px;
  padding: 1.25rem;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    max-width: 100%;
    padding: 0.85rem;
    border-radius: 12px;
  }
`;

export const OdsBanner = styled.div`
  width: 100%;
  margin-bottom: 0.75rem;

  img {
    display: block;
    width: 100%;
    height: auto;
    max-height: 120px;
    object-fit: contain;
    border-radius: 8px;
  }

  @media screen and (max-width: 768px) {
    img {
      max-height: 72px;
    }
  }
`;

export const OdsFooterImage = styled.img`
  display: block;
  width: 100%;
  max-width: 140px;
  height: auto;
  margin: 0.5rem auto 0;
  grid-column: 1 / -1;
  justify-self: center;

  @media screen and (max-width: 768px) {
    max-width: 100px;
  }
`;

export const AmbientalButton = styled.button `
  --background-color: var(--accent);
  background-color: var(--accent);
  border-radius: 100px;
  box-shadow: var(--shadow-sm);
  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular,-apple-system,system-ui,Roboto,sans-serif;
  padding: 3px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 11px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-right: 10px;
  width: 120px;
  height: 25px;

  :hover {
    box-shadow: var(--shadow-md);
    transform: scale(1.02) ;
    background-color: ligthGray;
  }

  :active {
    box-shadow: var(--shadow-md);
    transform: scale(1.02) ;
    background-color: darkGray;
  }
`;

export const Container = styled.div `
  --height: 100vh;
  --width: 90vw;
  --display: flex;
  --flex-direction: column;
  --justify-content: flex-start;
  --align-items: center;

  h2 {
    color: var(--text-heading);
    margin-bottom: 36px;
  }
`;

export const InnerContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 60vw;
  margin-left: 64px;
  text-align: left;

  @media screen and (max-width: 768px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    margin-left: 0 !important;
    box-sizing: border-box;
  }
`;

export const Column = styled.div `
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin: 10px;
  width: 630px;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr !important;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    gap: 12px;
  }
`;

export const Label = styled.label `
  margin-bottom: 10px;
  font-weight: 500;
`;

export const Input = styled(InputMask)`
  padding: 10px;
  margin-bottom: 20px;
  width: 430px;
  border: 2px solid var(--border-default);
  border-radius: 4px;
  padding: 8px;
  font-size: 16px;
  outline: none;

  ::placeholder {
    font-size: 12px;
  }

  &:focus {
    border-color: var(--accent);
  }

  @media screen and (max-width: 768px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    height: auto !important;
    min-height: 44px;
    padding: 0.7rem 0.85rem !important;
    font-size: 16px;
    box-sizing: border-box;
  }
`;

export const Span = styled.span `
  color: var(--text-primary);
  margin-bottom: 16px;
`;

export const ButtonContainer = styled.div `
  display: flex;
  flex-direction: row;
  --justify-content: flex-end;
  --align-items: center;
  --height: 5vw;
  --width: 93vw;
  margin-top: 32px;
  margin-bottom: 50px;
  padding-bottom: 50px;
  margin-left: 90px;
  float: left;
`;

export const Button = styled.button `
  background-color: var(--accent);
  border-radius: 10px;
  box-shadow: var(--shadow-sm);
  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular,-apple-system,system-ui,Roboto,sans-serif;
  padding: 7px 20px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 16px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-right: 16px;

  :hover {
  box-shadow: var(--shadow-md);
  transform: scale(1.02) ;
  }
`;

export const TextArea = styled.textarea `
  padding: 10px;
  margin-bottom: 20px;

  border: 2px solid var(--border-default);
  border-radius: 4px;
  padding: 8px;
  font-size: 16px;
  outline: none;

  &:focus {
    border-color: var(--accent);
  }
`;

export const ButtonLink = styled.button `
  background: none;
  border: none;
  color: var(--info);
  cursor: pointer;
  font: inherit;
  padding: 0;
  text-decoration: underline;
  font-weight: 400;
  font-size: 14px;
  text-decoration: none;
  margin-left: 170px;

  &:hover {
  color: var(--info);
  text-decoration: none;
}
`;

export const StyledSelect = styled(Select)`
  margin-bottom: 20px;
  width: 450px;
  border-radius: 4px;
  font-size: 16px;
  outline: none;

  &:focus {
    border-color: var(--accent);
  }

  @media screen and (max-width: 768px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    height: auto !important;
    min-height: 44px;
    padding: 0.7rem 0.85rem !important;
    font-size: 16px;
    box-sizing: border-box;
  }
`;

export const StyledSelectForUser = styled.select `
  border: 2px solid var(--border-default);
  border-radius: 4px;
  padding: 8px;
  font-size: 16px;
  outline: none;
  background: var(--input-bg);
  color: var(--text-muted);
  margin-bottom: 20px;
  width: 450px;
  font-size: 16px;
  outline: none;

  ::placeholder {
    font-size: 16px;
  }

  &:focus {
    border-color: var(--accent);
  }

  @media screen and (max-width: 768px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    height: auto !important;
    min-height: 44px;
    padding: 0.7rem 0.85rem !important;
    font-size: 16px;
    box-sizing: border-box;
  }
`;

export const DownloadButton = styled.button `
  margin: 16px;
  width: 100px;
`;

export const FileInput = styled.input.attrs({type: 'file'})`
  margin-left: 80px;
`;

export const TextInput = styled.textarea `
  height: 150px;
`;

export const List = styled.ul `
  list-style: none;
  padding: 0;
  margin-left: -140px;
  margin-top: 5px;
`;

export const List2 = styled.ul `
  list-style: none;
  padding: 0;
  margin-left: -10px;
  margin-top: 0px;
`;

export const ListItem = styled.li `
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  border: 2px solid var(--border-subtle);
  border-radius: 50px;  
  transition: background-color 0.3s;
  align-text: left;
  color: var(--text-primary);

  --width: 65vw;
  --margin: 10px;
  --min-height: 25px;

  &:hover {
    background-color: var(--table-row-hover);
  }

  div {
    --width: 100%;
    --display: flex;
    --flex-direction: row;
    --align-items: center;
    --justify-content: center;    
  }

  span {
    font-size: 20px;
  }

  @media screen and (max-width: 768px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    margin-left: 0 !important;
    box-sizing: border-box;
  }
`;

export const ContainerNewButton = styled.li `
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  border: 2px solid var(--border-subtle);
  border-radius: 50px;  
  transition: background-color 0.3s;
  text-align: left;
  color: var(--text-primary);
  background-color: var(--input-bg); /* Alterado para branco */
  width: 89%;
  min-height: 25px;
  height: 50px;
  margin-top: 20px;
  margin-bottom: 50px;
  float: left;
  position: relative; /* Mantendo o posicionamento relativo */
  top: 50px; /* Movendo para baixo */

  &:hover {
    background-color: var(--table-row-hover);
  }

  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;    
    width: 100%;
  }

  span {
    font-size: 20px;
  }
`;

export const StyledButtonCancelar = styled.button `
  background-color: #FFA07A;
  border-radius: 100px;
  box-shadow: 
    rgba(255, 160, 122, 0.2) 0 -25px 18px -14px inset,
    rgba(255, 160, 122, 0.15) 0 1px 2px,
    rgba(255, 160, 122, 0.15) 0 2px 4px,
    rgba(255, 160, 122, 0.15) 0 4px 8px,
    rgba(255, 160, 122, 0.15) 0 8px 16px,
    rgba(255, 160, 122, 0.15) 0 16px 32px;

  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 3px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 10px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-left: 0px;
  width: 55px;
  height: 20px;

  :hover {
    box-shadow: 
      rgba(255, 160, 122, 0.35) 0 -25px 18px -14px inset,
      rgba(255, 160, 122, 0.35) 0 1px 2px,
      rgba(255, 160, 122, 0.35) 0 2px 4px,
      rgba(255, 160, 122, 0.35) 0 4px 8px,
      rgba(255, 160, 122, 0.35) 0 8px 16px,
      rgba(255, 160, 122, 0.35) 0 16px 32px;
    transform: scale(1.02);
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

export const StyledButtonDownload = styled.button `
  background-color: #7CFCB8; /* Verde claro, menos neon */
  border-radius: 100px;
  box-shadow: 
    rgba(124, 252, 184, 0.2) 0 -25px 18px -14px inset,
    rgba(124, 252, 184, 0.15) 0 1px 2px,
    rgba(124, 252, 184, 0.15) 0 2px 4px,
    rgba(124, 252, 184, 0.15) 0 4px 8px,
    rgba(124, 252, 184, 0.15) 0 8px 16px,
    rgba(124, 252, 184, 0.15) 0 16px 32px;

  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 3px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 10px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-left: 0px;
  width: 55px;
  height: 20px;

  :hover {
    box-shadow: 
      rgba(124, 252, 184, 0.35) 0 -25px 18px -14px inset,
      rgba(124, 252, 184, 0.35) 0 1px 2px,
      rgba(124, 252, 184, 0.35) 0 2px 4px,
      rgba(124, 252, 184, 0.35) 0 4px 8px,
      rgba(124, 252, 184, 0.35) 0 8px 16px,
      rgba(124, 252, 184, 0.35) 0 16px 32px;
    transform: scale(1.02);
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

export const StyledButtonLogs = styled.button `
  background-color: #D8BFD8; /* Lavanda claro */
  border-radius: 100px;
  box-shadow: 
    rgba(216, 191, 216, 0.2) 0 -25px 18px -14px inset,
    rgba(216, 191, 216, 0.15) 0 1px 2px,
    rgba(216, 191, 216, 0.15) 0 2px 4px,
    rgba(216, 191, 216, 0.15) 0 4px 8px,
    rgba(216, 191, 216, 0.15) 0 8px 16px,
    rgba(216, 191, 216, 0.15) 0 16px 32px;

  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 3px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 10px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-left: 0px;
  width: 55px;
  height: 20px;

  :hover {
    box-shadow: 
      rgba(216, 191, 216, 0.35) 0 -25px 18px -14px inset,
      rgba(216, 191, 216, 0.35) 0 1px 2px,
      rgba(216, 191, 216, 0.35) 0 2px 4px,
      rgba(216, 191, 216, 0.35) 0 4px 8px,
      rgba(216, 191, 216, 0.35) 0 8px 16px,
      rgba(216, 191, 216, 0.35) 0 16px 32px;
    transform: scale(1.02);
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

// file upload sub topicos
export const ListItemDiv = styled.div `
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  border: 2px solid var(--border-default);
  border-radius: 45px;  
  transition: background-color 0.3s;
  text-align: left;
  color: var(--text-primary);
  width: 70vw;  
  background-color: var(--surface-2);  
  margin-top: 3px;
  overflow: hidden;  

  &:hover {
    background-color: var(--table-row-hover);
  }

  span {
    font-size: 20px;
  }

  @media screen and (max-width: 768px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    margin-left: 0 !important;
    box-sizing: border-box;
  }
`;

export const ListSubItemDiv = styled.div `
  display: grid;
  grid-template-columns: 3fr 1fr ;
  gap: '20px'
  align-items: center;
  border: 2px solid var(--border-default);
  border-radius: 45px;  
  transition: background-color 0.3s;
  text-align: left;
  color: var(--text-primary);
  width: 900px;  /* Largura fixa */
  height: 50px; /* Altura fixa */ 
  background-color: var(--surface-2);  
  margin-top: 3px;
  overflow: hidden;  
  padding: 8px;
  margin-left: -1vw; /* encosta na esquerda */
  //margin-right: auto; /* "empurra" para esquerda */

  &:hover {
    background-color: var(--table-row-hover);
  }


  span {
    font-size: 20px;
  }

  @media screen and (max-width: 768px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    margin-left: 0 !important;
    box-sizing: border-box;
  }
`;

export const BlockchainText = styled.div `
  color: var(--text-heading);
  font-size: 16pt;
  background-color: var(--surface-2);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%; /* Garante centralização dentro do container */
  border: 2px solid var(--border-subtle);
  border-radius: 10px;
  transition: background-color 0.3s;
  color: var(--text-primary);
`;

export const ContractContainer = styled.div `
  background-color: var(--text-primary); 
  border-radius: 12px; 
  box-shadow: var(--shadow-sm); 
  padding: 15px; 
  max-width: 700px; 
  width: 100%; 
  margin: 20px auto; 
`;

export const ContractItem = styled.div `
  display: flex;
  justify-content: flex-start; 
  align-items: center; 
  padding: 8px 16px;
  width: 100%;
  margin-bottom: 8px;
`;

export const ContractLabel = styled.div `
  font-weight: 600;
  color: var(--text-primary);
  font-size: 11.5pt;
  margin-right: 2px; 
  white-space: nowrap; 
  text-align: left;
`;

export const ContractValue = styled.div `
  color: var(--text-secondary);
  font-size: 11pt;
  text-align: left;
  word-break: break-word; 
  overflow: hidden; 
  text-overflow: ellipsis; 
  max-width: 70%; 
`;

export const ModalOverlaynft = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--surface-glass); /* Fundo um pouco mais escuro para maior contraste */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  overflow: hidden;
`;

export const ModalContentnft = styled.div `
  background: var(--input-bg);
  padding: 30px;
  border-radius: 12px;
  width: 60%; 
  color: var(--text-primary);
  position: relative; 
  overflow: hidden;
  max-width: 900px; 
  box-shadow: var(--shadow-sm); 

  display: flex;
  flex-direction: column; /* organiza em coluna */
  justify-content: center; /* centraliza verticalmente os filhos */
  align-items: center; /* centraliza horizontalmente os filhos */
`;

export const StylednftContainer = styled.div `
  background-color: var(--surface-2); 
  border-radius: 12px; 
  box-shadow: var(--shadow-sm); 
  padding: 20px;
  width: 80%; 
  display: flex;
  flex-wrap: wrap; 
  flex-direction: row; 
  justify-content: center; /* centraliza os itens internamente */
  
`;

export const StylednftItem = styled.div `
  display: flex;
  align-items: center; 
  padding: 5px 0; 
  width: 100%;
`;

export const StylednftLabel = styled.div `
  font-weight: 600;
  color: var(--text-primary);
  font-size: 13pt;
  margin-right: 10px;
  white-space: nowrap; 
  text-align: left;
`;

export const StylednftValue = styled.div `
  color: var(--text-secondary);
  font-size: 12pt;
  text-align: left;
  word-break: break-word; 
  overflow: hidden; 
  text-overflow: ellipsis; 
  max-width: 70%;
  text-align: right; /* Alinha os valores à direita para melhor visualização */
`;

export const ListItemDivContract = styled.div `
  position: relative;
  width: 70vw;
  margin-top: 1vw;
`;

export const StyledButtonCriarContract = styled.button `
  position: absolute;
  right: 1px;
  top: 50%;
  transform: translateY(-150%);
  background-color: var(--accent);
  color: var(--text-on-accent);
  padding: 8px 20px;
  border: none;
  border-radius: 60px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background-color: var(--accent-hover);
  }
`;

export const StyledButtonVerContrato = styled.button `
  position: absolute;
  right: 1px;
  top: 50%;
  transform: translateY(-150%);
  background-color: var(--info); /* Azul para diferenciar */
  color: var(--text-on-accent);
  padding: 8px 20px;
  border: none;
  border-radius: 60px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background-color: var(--info);
  }
`;


export const ModalOverlay = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  justify-content: center; 
  align-items: center; 
  background: var(--surface-overlay);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  overflow: hidden;

`;

export const ModalContent = styled.div `
  background: var(--input-bg);
  padding: 10px;
  border-radius: 12px;
  width: 50%;
  color: var(--text-primary);
  position: absolute;
  overflow: hidden;
  
`;

export const ModalTitle = styled.h2 `
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  color: var(--accent);
  text-align: center;
`;

export const CloseButton = styled.button `
  position: absolute;
  top: 12px;
  right: 16px;
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: var(--danger);
`;

export const StyledButtonConfirmarDocs = styled.button `
  background-color: var(--accent);
  border-radius: 100px;
  box-shadow: var(--shadow-sm);
  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular,-apple-system,system-ui,Roboto,sans-serif;
  padding: 3px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 11px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-right: 10px;
  width: 120px;
  height: 25px;

  :hover {
    box-shadow: var(--shadow-md);
    transform: scale(1.02) ;
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

export const StyledButtonSalvar = styled.button `
background-color: var(--accent);
  border-radius: 100px;
  box-shadow: var(--shadow-sm);
  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 6px 10px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 75%;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 7vw;
  height: 5vh;
  z-index: 1;

  :hover {
    box-shadow: var(--shadow-md);
    transform: scale(1.05);
  }

  @media screen and (max-width: 768px) {
    font-size: 12px;
    width: 130px;
    height: 30px;
  }
`;

export const StyledButtonSalvarUnico = styled.button `
  --background-color: var(--accent);
  background-color: var(--accent);
  border-radius: 100px;
  box-shadow: var(--shadow-sm);
  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular,-apple-system,system-ui,Roboto,sans-serif;
  padding: 3px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 11px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-right: 10px;
  width: 25px;
  height: 25px;

  :hover {
    box-shadow: var(--shadow-md);
    transform: scale(1.02) ;
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

export const StyledButtonNovo = styled.button `
  background-color: var(--accent);
  border-radius: 100px;
  box-shadow: var(--shadow-sm);
  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 6px 10px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 75%;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 7vw;
  height: 5vh;
  z-index: 1;

  :hover {
    box-shadow: var(--shadow-md);
    transform: scale(1.05);
  }

  @media screen and (max-width: 768px) {
    font-size: 12px;
    width: 130px;
    height: 30px;
  }
`;

export const StyledButtonPesquisar = styled.button `
  background-color: var(--accent);
  border-radius: 100px;
  box-shadow: var(--shadow-sm);
  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 6px 10px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 75%;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 7vw;
  height: 5vh;
  z-index: 1;

  :hover {
    box-shadow: var(--shadow-md);
    transform: scale(1.05);
  }

  @media screen and (max-width: 768px) {
    font-size: 12px;
    width: 130px;
    height: 30px;
  }
`;

export const StyledButtonIniciarEtapa = styled.button `
  background-color: #F4A460;  
  border-radius: 40px;  
  color: var(--text-on-accent);  
  cursor: pointer;  
  display: inline-block;  
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;  
  text-align: center; 
  border: 0;  
  font-size: 62%;  
  user-select: none;  
  touch-action: manipulation;  
  width: 5vw;  
  height: 4vh;  
  
  // Estilo aplicado quando o botão está sendo "hovered" (passado o mouse sobre o botão)
  :hover {
    box-shadow: rgba(255,69,0,.35) 0 -25px 18px -14px inset,  // Aumenta a intensidade da sombra interna
                rgba(255,69,0,.35) 0 1px 2px, // Intensifica as sombras externas
                rgba(255,69,0,.35) 0 2px 4px, 
                rgba(255,69,0,.35) 0 4px 8px,
                rgba(255,69,0,.35) 0 8px 16px,
                rgba(255,69,0,.35) 0 16px 32px;
    transform: scale(1.02);  
  }

  // Estilo responsivo para dispositivos com largura máxima de 768px (geralmente tablets ou menores)
  @media screen and (max-width: 768px) {
    font-size: 10px;  // Define o tamanho da fonte como 10px quando a tela for menor que 768px
  }
`;

export const StyledButtonIniciado = styled.button `
  background-color: #FFFF00;
  border-radius: 40px;  
  color: var(--text-on-accent);  
  cursor: pointer;  
  display: inline-block;  
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;  
  text-align: center; 
  border: 0;  
  font-size: 62%;  
  user-select: none;  
  touch-action: manipulation;  
  width: 5vw;  
  height: 4vh;  

  :hover {
    box-shadow: rgba(255,255,0,.35) 0 -25px 18px -14px inset,
                rgba(255,255,0,.35) 0 1px 2px,
                rgba(255,255,0,.35) 0 2px 4px,
                rgba(255,255,0,.35) 0 4px 8px,
                rgba(255,255,0,.35) 0 8px 16px,
                rgba(255,255,0,.35) 0 16px 32px;
    transform: scale(1.02) ;
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
  }
`;


export const StyledButtonMintNft = styled.button `
  background-color: #F5DEB3;
  border-radius: 100px;
  box-shadow: rgba(245, 222, 179, 0.2) 0 -25px 18px -14px inset,
              rgba(245, 222, 179, 0.15) 0 1px 2px,
              rgba(245, 222, 179, 0.15) 0 2px 4px,
              rgba(245, 222, 179, 0.15) 0 4px 8px,
              rgba(245, 222, 179, 0.15) 0 8px 16px,
              rgba(245, 222, 179, 0.15) 0 16px 32px;
  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 3px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 10px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-left: 0px;
  width: 55px;
  height: 20px;

  :hover {
    box-shadow: rgba(245, 222, 179, 0.35) 0 -25px 18px -14px inset,
                rgba(245, 222, 179, 0.35) 0 1px 2px,
                rgba(245, 222, 179, 0.35) 0 2px 4px,
                rgba(245, 222, 179, 0.35) 0 4px 8px,
                rgba(245, 222, 179, 0.35) 0 8px 16px,
                rgba(245, 222, 179, 0.35) 0 16px 32px;
    transform: scale(1.02);
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

export const StyledButtonShowNft = styled.button `
  background-color: var(--accent-secondary);
  border-radius: 100px;
  box-shadow: rgba(255,20,147, .2) 0 -25px 18px -14px inset,rgba(255,20,147, .15) 0 1px 2px,rgba(255,20,147, .15) 0 2px 4px,rgba(255,20,147, .15) 0 4px 8px,rgba(255,20,147, .15) 0 8px 16px,rgba(255,20,147, .15) 0 16px 32px;
  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular,-apple-system,system-ui,Roboto,sans-serif;
  padding: 3px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 10px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-left: 0px;
  width: 55px;
  height: 20px;

  :hover {
    box-shadow: rgba(255,20,147,.35) 0 -25px 18px -14px inset,rgba(255,20,147,.35) 0 1px 2px,rgba(255,20,147,.35) 0 2px 4px,rgba(255,20,147,.35) 0 4px 8px,rgba(255,20,147,.35) 0 8px 16px,rgba(255,20,147,.35) 0 16px 32px;
    transform: scale(1.02) ;
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

export const StyledButtonSubstituirNft = styled.button `
  background-color: #FFFF00;
  border-radius: 100px;
  box-shadow: rgba(255,20,147, .2) 0 -25px 18px -14px inset,rgba(255,20,147, .15) 0 1px 2px,rgba(255,20,147, .15) 0 2px 4px,rgba(255,20,147, .15) 0 4px 8px,rgba(255,20,147, .15) 0 8px 16px,rgba(255,20,147, .15) 0 16px 32px;
  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular,-apple-system,system-ui,Roboto,sans-serif;
  --padding: 3px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 10px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-left: 0px;
  width: 55px;
  height: 20px;

  :hover {
    box-shadow: rgba(255,20,147,.35) 0 -25px 18px -14px inset,rgba(255,20,147,.35) 0 1px 2px,rgba(255,20,147,.35) 0 2px 4px,rgba(255,20,147,.35) 0 4px 8px,rgba(255,20,147,.35) 0 8px 16px,rgba(255,20,147,.35) 0 16px 32px;
    transform: scale(1.02) ;
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
  }
`;
// estou mexendo aquiiii
export const CardContainer = styled.div `
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(3, auto);
  gap: 6px;
  position: relative;
  justify-content: start;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }

  @media (max-width: 380px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const CardTopo = styled.div `
  position: relative;
  width: 100%;
`;

export const styleFileUpload = {
	// painel inteiro
	containerFileUpload: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		width: '70vw',
		border: '2px dashed var(--border-default)',
		borderRadius: '10px',
		backgroundColor: 'var(--surface-2)',
		padding: '3%',
		marginTop: '10vh',
		boxShadow: 'var(--shadow-sm)',
		overflow: 'hidden',
		marginLeft: '0'
	},

	// css do fileUpload
	centerTitle: {
		textAlign: 'center',
		marginTop: '-5px'
	},

	progressBarContainer: {
		width: '69vw',
		height: '5vh',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		paddingLeft: '5px',
		paddingRight: '15px',
		overflow: 'hidden',
		borderRadius: '50px'
	},

	expansor: {
		float: 'left',
		marginRight: '0.5vw',
		marginLeft: '0.5vw',
		color: 'var(--text-secondary)'
	},

	numberTopic: {
		fontWeight: 'bold',
		color: 'var(--text-primary)',
		width: '4vw',
		// backgroundColor: 'rgba(212, 91, 192, 0.93)',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},

	progressBar: {
		// marginLeft: '-60px',
		width: '12vw',
		height: '8vh',
		// backgroundColor: 'rgba(212, 91, 192, 0.93)',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		marginRight: '1.5vh'
	},

	labelTopic: {
		fontSize: '7.5pt',
		marginRight: '1.5vh'
	},

	buttonIniciar: {
		display: 'flex', // Flexbox para alinhar os itens
		justifyContent: 'flex-end', // Alinha os itens à direita
		alignItems: 'center',
		// Alinha verticalmente os itens no centro
		// backgroundColor: 'rgba(212, 91, 192, 0.93)',
		width: '8vw',
		marginLeft: 'auto', // Isso empurra a div para a direita
	},


	/*botão de salvar no fim da pagina */
	buttonContainer: {
		float: 'left',
		// backgroundColor: 'lightgrey',
		height: '8vh',
		borderRadius: '100px 0px 0px 100px',
		width: '10vw',
		backgroundColor: 'var(--accent)'
	},

	styleSmall: {
		float: 'left',
		width: '80vw',
		color: 'var(--danger)',
		backgroundColor: 'var(--info)'
	},

	confirmContainer: {
		display: 'flex',
		justifyContent: 'center', // centraliza horizontalmente o container
		alignItems: 'center', // alinha todos os itens verticalmente no centro
		width: '100%',
		marginTop: '20px',
		gap: '10px'
	},

	checkboxArea: {
		display: 'flex',
		alignItems: 'center',
		height: '100%'
	},

	labelConfirmacao: {
		display: 'flex',
		alignItems: 'center',
		cursor: 'pointer',
		height: '100%',
		fontSize: '14px',
		maxWidth: '350px'
	},

	botaoConfirmar: {
		display: 'flex',
		alignItems: 'center', // alinha o botão com o texto
		height: '100%'
	}

};

export const styles = {

	tabletMenu: {
		overflow: 'hidden',
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		position: 'relative',
		justifyContent: 'center',
		alignItems: 'stretch',
		boxSizing: 'border-box',
	},

	menu: {
		overflow: 'auto',
		position: 'relative',
		display: 'grid',
		gridTemplateColumns: 'repeat(5, 1fr)',
		gridTemplateRows: 'repeat(2, auto)',
		gap: '6px',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%',
		maxWidth: '100%',
		height: 'auto',
		boxSizing: 'border-box',
	},

	menuItem: (isActive, isHovered, collapsed) => (
		{
			cursor: 'pointer',
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'flex-start',
			width: '100%',
			height: '56px',
			textAlign: 'left',
			borderRadius: '10px',
			backgroundColor: isActive ? 'var(--accent-soft)' : isHovered ? 'var(--surface-2)' : 'var(--surface-2)',
			border: isActive ? '2px solid var(--accent)' : isHovered ? '2px solid var(--accent-secondary)' : '2px solid var(--border-subtle)',
			color: 'var(--text-primary)',
			padding: collapsed ? '12px 16px' : '6px 12px',
			transition: 'all 0.25s ease',
			transform: isHovered && !isActive ? 'translateY(-2px)' : 'translateY(0)',
			boxSizing: 'border-box',
		}
	),

	pagina: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
		width: '100%',
		maxWidth: '100%',
		marginTop: '0.75rem',
		marginLeft: 'auto',
		marginRight: 'auto',
		textAlign: 'left',
		minHeight: 0,
		overflowX: 'hidden',
		boxSizing: 'border-box',
		padding: '0 0 1rem',
	},

	WhiteSection: {
		maxWidth: '900px',
		width: '100%',
		margin: '0.75rem auto',
		backgroundColor: 'var(--surface-1)',
		border: '1px solid var(--border-subtle)',
		borderRadius: '12px',
		padding: '1.25rem',
		boxSizing: 'border-box'
	}
};

export const subTopicos = {
	container: {
		overflow: 'hidden',
		width: '100%',
		height: '100%',
		position: 'relative',
		boxSizing: 'border-box',
		margin: '5px'
	},

	strongText: {
		color: 'black',
		fontSize: '8pt',
		marginRight: '2px'

	},

	documentDiv: {
		cursor: 'pointer',
		position: 'absolute',
		bottom: '0',
		margin: '2px 15px '
	},

	buttons: {
		width: '340px',
		height: '30px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		alignSelf: 'center'
	}
};

/** aquiiiiiiiii */

export const ShowInput = styled.input `
  width: 100%;
  max-width: 17vw;
  height: 2.75vh;
  border: 0.052vw solid var(--border-default);
  border-radius: 0.417vw;
  padding: 0.417vw;
  font-size: 0.8vw;
  outline: none;
  background: var(--input-bg);
  transition: all 0.3s ease-in-out;
  color: var(--text-muted);

  &:focus {
    border-color: var(--accent);
    background: var(--surface-1);
    color: var(--text-primary);
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: none;
  }
`;

export const Card = styled.div `
  border-radius: 3px;
  box-shadow: var(--shadow-sm);
  cursor: pointer;
  width: 90px;
  height: 90px;
  transition: border-color 0.3s, background-color 0.3s, opacity 0.3s;
  opacity: ${
    (props) => (props.isSelected ? '1' : '0.3')
  };
  border: ${
    (props) => (props.isSelected ? '5px solid White' : '5px solid transparent')
  };
  
  display: flex; /* Centraliza a imagem dentro do card */
  align-items: center;
  justify-content: center;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* Garante que a imagem se encaixe bem */
  }

  &:hover {
    border-color: var(--text-on-accent);
    background-color: lightblue;
  }
`;
